import { render, staticRenderFns } from "./l-task.vue?vue&type=template&id=4f676b60&scoped=true"
import script from "./l-task.vue?vue&type=script&lang=js"
export * from "./l-task.vue?vue&type=script&lang=js"
import style0 from "./l-task.vue?vue&type=style&index=0&id=4f676b60&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f676b60",
  null
  
)

export default component.exports